/**
 * @author      Suyog Manandhar
 * @version     2.0
 * @description This stateless functional component, CollapsibleBdoy, is the view for the {@link UpdateCollapse}
 *              Body Section
 *
 */

import React, { useMemo } from "react";
import Select from "react-select";

const CollapisbleBody = (props) => {
  const classroomTeachersOptions = useMemo(() => {
    if (props?.classroomTeachers?.length === 0) return [];

    return props?.classroomTeachers?.map((item) => ({
      label: item?.people?.name,
      value: item?.id,
    }));
  }, [props.classroomTeachers]);

  const SelectStyle = {
    control: (base, state) => ({
      ...base,
      backgroundColor: state.isDisabled ? "#e9ecef" : "white",
      color: "#495057",
      cursor: state.isDisabled ? "not-allowed" : "default",
      border: "1px solid #ced4da",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#126696"
        : state.isFocused
          ? "#d8e7f0"
          : "inherit",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  return (
    <form action="">
      <div className="form-group row">
        <div className="col-md-2"></div>
        <div className="col-md-3 text-right">
          <label htmlFor="name">
            <strong>{localStorage.getItem("classroom")} Name : </strong>
          </label>
        </div>
        <div className="col-md-4">
          <input
            type="text"
            name="name"
            className="form-control"
            value={props.name}
            onChange={props.handleChange}
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="col-md-2"></div>
        <div className="col-md-3 text-right">
          <label htmlFor="recruitmentId">
            <strong>{localStorage.getItem("classroom")} Teacher : </strong>
          </label>
        </div>
        <div className="col-md-4">
          <Select
            options={classroomTeachersOptions}
            onChange={props.handleSectionTeacherChange}
            value={
              classroomTeachersOptions?.find(
                (opt) => opt.value === props.recruitmentId,
              ) || null
            }
            styles={SelectStyle}
            isClearable
          />
          {/* <select
            name="recruitmentId"
            className="form-control"
            value={props.recruitmentId}
            onChange={props.handleChange}
          >
            <option value="" disabled>
              Choose {localStorage.getItem("classroom")} Teacher
            </option>
            {props.classroomTeachers.map((classTeacher, idx) => {
              return (
                <option value={classTeacher.id} key={idx}>
                  {classTeacher.people.name}
                </option>
              );
            })}
          </select> */}
        </div>
      </div>
      <div className="form-group row">
        <div className="col-md-2"></div>
        <div className="col-md-3 text-right">
          <label htmlFor="roomId">
            <strong>{localStorage.getItem("classroom")} Location : </strong>
          </label>
        </div>
        <div className="col-md-4">
          <select
            name="roomId"
            className="form-control"
            value={props.roomId}
            onChange={props.handleChange}
          >
            <option value="" disabled>
              Choose a {localStorage.getItem("classroom")} location
            </option>
            {props.classroomLocations.map((room, idx) => {
              let roomName = ` ${room.name}(${room.number}) - ${room.buildingName}, ${room.buildingSectionAliasName} ${room.buildingSectionName}, ${room.floorName}`;
              return (
                <option key={idx} value={room.id}>
                  {roomName}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      <div className="form-group row">
        <div className="col-md-2"></div>
        <div className="col-md-3"></div>
        <div className="col-md-4 text-right">
          <button
            className="tt-button tt-button-primary mr-4"
            onClick={(e) => {
              props.updateTuple(e, props.classroom.id);
            }}
          >
            Update
          </button>
          <button
            className="tt-button tt-button-primary"
            onClick={props.handleSectionLevelCancelBtnClick}
          >
            Cancel
          </button>
        </div>
      </div>
    </form>
  );
};

export default CollapisbleBody;
